export const haversineDistance = (lat1, lon1, lat2, lon2) => {
  const toRad = (value) => (value * Math.PI) / 180

  const R = 3958.8 // Radius of Earth in miles
  const dLat = toRad(lat2 - lat1)
  const dLon = toRad(lon2 - lon1)

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return R * c
}

export function hasSignificantBoundsChange(oldBounds, newBounds, threshold = 0.1) {
  if (!oldBounds || !newBounds) return true

  const oldNE = oldBounds.getNorthEast()
  const oldSW = oldBounds.getSouthWest()
  const newNE = newBounds.getNorthEast()
  const newSW = newBounds.getSouthWest()

  const latDiff = Math.abs(oldNE.lat() - newNE.lat()) + Math.abs(oldSW.lat() - newSW.lat())
  const lngDiff = Math.abs(oldNE.lng() - newNE.lng()) + Math.abs(oldSW.lng() - newSW.lng())

  // Normalize change based on the current viewport size
  const latSize = Math.abs(oldNE.lat() - oldSW.lat())
  const lngSize = Math.abs(oldNE.lng() - oldSW.lng())

  return latDiff + lngDiff > threshold * (latSize + lngSize)
}
